import React from 'react';
import { useTranslations } from 'next-intl';
import { EditReceipt, Mark } from '@/components/icons';
import CardFooter from '@/components/user/address/card-footer';
import { Ping } from '../icons';

function AddressCard({
  address,
  handleEdit,
  handleDefaultAddress,
  isMutating,
  isDefault,
  mage,
  onDeleteSuccess,
}) {
  const t = useTranslations('');

  return (
    <div className='border-border relative w-full rounded-lg border'>
      <div
        className={`flex items-center justify-between rounded-t-lg px-4 py-2 ${
          isDefault && 'bg-gray-100'
        }`}
      >
        <button
          onClick={() =>
            isDefault || isMutating ? null : handleDefaultAddress(address)
          }
          disabled={isMutating || isDefault}
          className={`text-primary flex items-center gap-2 transition-all ${
            isDefault
              ? 'cursor-default font-bold'
              : isMutating
                ? 'cursor-not-allowed opacity-50'
                : 'hover:text-primary-dark cursor-pointer underline'
          }`}
        >
          {isMutating && <Ping />}
          <span>
            {isDefault ? t('user.default_key') : t('user.mark_as_default_key')}
          </span>
        </button>
      </div>

      <div className='p-4 pt-2'>
        <h3 className='font-bold'>{address.firstname}</h3>
        <p className='text-muted'>
          {address.city}, {address.region.region} <br />
          {address.street.join(', ')} <br />
          {address.postcode}
        </p>

        <div className='mt-2 flex items-center gap-2'>
          <Mark />
          <p className='text-muted'>{address.telephone}</p>
        </div>

        <div className='mt-4 flex items-center justify-between gap-4'>
          <div className='flex items-center gap-2'>
            <EditReceipt />
            <button
              onClick={() => handleEdit(address)}
              disabled={isMutating}
              className={`text-primary hover:text-primary-dark cursor-pointer underline`}
            >
              {t('user.edit_address_key')}
            </button>
          </div>

          {!isDefault && (
            <CardFooter
              id={address?.id}
              onDeleteSuccess={onDeleteSuccess}
              mage={mage}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default AddressCard;
